const fetchLeadsTransformer = response => {
  return {
    ...response,
    ExternalInquiryAdditionalData: response?.ExternalInquiryAdditionalData?.reduce((acc, field) => {
      const key = field?.SocialCampaignFieldMapping?.ExternalInquiryField?.id?.toString()
      const value = field?.value

      if (key) {
        acc[key] = value
      }

      return acc
    }, {}),
  }
}

export default fetchLeadsTransformer
